import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import LimitedFunctionalityList from '../LimitedFunctionalityList'
import {CURRENT_PRODUCT} from '../../../../constants'

export default class LimitedFunctionalityDialog extends TemplateView {
    constructor() {
        super()

        this.state = {
            unavailableInFreeFeatures: []
        }

        this.onStatePropertyChanged('unavailableInFreeFeatures', (unavailableInFreeFeatures) => {
            this.limitedFunctionalityList.setState({unavailableInFreeFeatures})
        })
    }

    templateHtml() {
        return '<div class="limitedFunctionalityDialog">' +
               '    <div class="note"><%=limitedFunctionalityNote%></div>' +
               '    <div class="listContainer"/>' +
               '</div>'
    }

    templateModel() {
        return {
            limitedFunctionalityNote: messageResource.getMessage('licenses.chooser.limited_functionality.note', [CURRENT_PRODUCT]),
        }
    }

    afterRender() {
        this.limitedFunctionalityList = new LimitedFunctionalityList().init(this.find('.listContainer'))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/LimitedFunctionalityDialog.js